import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';

@Component({
  selector: 'hypenation-tickets-event-skeleton',
  standalone: true,
  imports: [CommonModule, NzSkeletonModule],
  templateUrl: './event-skeleton.component.html',
  styleUrl: './event-skeleton.component.css',
})
export class EventSkeletonComponent {}
